import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=05d28750"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
import style0 from "./Summary.vue?vue&type=style&index=0&id=05d28750&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports